import * as Actions from './actions'
import initialState from '../store/initialState'

export const SortReducer = (state = initialState.sort, action: any) => {
    switch (action.type) {
        case Actions.SET_SORT_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}